import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Target, Dumbbell, ArrowRight } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { SEO } from "@/components/SEO";
import { PageHero, Loading } from "@/components/shared";

export default function AgeGroups() {
  const [groups, setGroups] = useState(null);
  useEffect(() => { api.get("/public/age_groups").then((r) => setGroups(r.data)); }, []);

  return (
    <>
      <SEO title="Age Groups | Brackenfell Junior Rugby Club" description="Explore BJRC age groups and rugby development pathways from U7 through to the senior youth groups." />
      <PageHero title="Age Groups" subtitle="Age-appropriate rugby development, tailored to each stage of your child's growth." />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {groups === null ? <Loading /> : (
          <div className="space-y-10">
            {groups.map((g, idx) => (
              <div key={g.id} className={`grid gap-8 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:grid-cols-2 md:p-8 ${idx % 2 ? "md:[&>div:first-child]:order-2" : ""}`} data-testid={`age-group-${g.name}`}>
                <div className="relative overflow-hidden rounded-2xl bg-[#0B2A4A]" style={{ minHeight: 240 }}>
                  {g.image_url ? <img src={mediaUrl(g.image_url)} alt={g.name} className="h-full w-full object-cover" /> : (
                    <div className="flex h-full min-h-[240px] items-center justify-center font-heading text-8xl font-black text-white/15">{g.name}</div>
                  )}
                  <span className="absolute left-5 top-5 rounded-xl bg-[#E8A317] px-4 py-1.5 font-heading text-2xl font-extrabold text-[#0A1626]">{g.name}</span>
                </div>
                <div>
                  <h2 className="font-heading text-2xl font-extrabold uppercase text-[#0B2A4A]">{g.name} Rugby</h2>
                  <p className="mt-3 text-slate-700">{g.description}</p>
                  {Array.isArray(g.objectives) && g.objectives.length > 0 && (
                    <div className="mt-5">
                      <div className="flex items-center gap-2 font-bold uppercase tracking-wide text-[#1E63D6]"><Target className="h-4 w-4" /> Development Objectives</div>
                      <ul className="mt-2 space-y-1.5 text-sm text-slate-600">
                        {g.objectives.map((o, i) => <li key={i} className="flex gap-2"><span className="text-[#E8A317]">▸</span>{o}</li>)}
                      </ul>
                    </div>
                  )}
                  {Array.isArray(g.skills) && g.skills.length > 0 && (
                    <div className="mt-5">
                      <div className="flex items-center gap-2 font-bold uppercase tracking-wide text-[#1E63D6]"><Dumbbell className="h-4 w-4" /> Key Rugby Skills</div>
                      <div className="mt-2 flex flex-wrap gap-2">
                        {g.skills.map((s, i) => <span key={i} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">{s}</span>)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="mt-12 text-center">
          <Link to="/join" className="inline-flex items-center gap-2 rounded-full bg-[#0B2A4A] px-8 py-3.5 font-extrabold uppercase text-white hover:bg-[#071B30]">Enquire to Join <ArrowRight className="h-5 w-5" /></Link>
        </div>
      </section>
    </>
  );
}
